import * as React from 'react';
import { UserFormState } from '../../../containers/application/states/UserFormState';
import { ButtonWrapper, SubmitButton } from '../../atoms/forms/vertical/base';
import { VerticalStringInput, VerticalSelectInput } from '../../../../commonv3/components/atoms/forms/vertical';
import './userForm.module.scss';

function getAgeOptions() {
    const result = [];
    for (let i = 5; i < 100; ++i) {
        result.push({
            label: `${i}才`,
            value: i,
        });
    }
    return result;
}

type Props = {
    state: UserFormState;
    submitting: boolean;
    onSubmit: () => any;
    buttonLabel?: string;
    showPasswordFields?: boolean;
};

export class UserForm extends React.Component<Props> {
    render() {
        const { state, submitting, onSubmit, buttonLabel = '次へ', showPasswordFields = false } = this.props;
        return (
            <>
                <VerticalStringInput
                    id="name"
                    size="l"
                    label="お名前"
                    type="text"
                    placeholder="例：山田花子"
                    state={state.fields.name}
                />
                <VerticalStringInput
                    id="furigana"
                    size="l"
                    label="フリガナ"
                    type="text"
                    placeholder="例：ヤマダ ハナコ"
                    state={state.fields.furigana}
                />
                <VerticalStringInput
                    id="email"
                    size="l"
                    label="メールアドレス"
                    type="text"
                    placeholder="例：hanako@she-inc.co.jp"
                    state={state.fields.email}
                />
                <VerticalSelectInput
                    id="age"
                    styleName="small"
                    label="年齢"
                    options={getAgeOptions()}
                    placeholder={'--'}
                    state={state.fields.age}
                    serializer={(v) => v}
                    deserializer={(v) => v}
                />
                {showPasswordFields && (
                    <VerticalStringInput
                        id="password"
                        size="l"
                        label="パスワード"
                        type="password"
                        placeholder="6文字以上"
                        state={state.fields.password}
                    />
                )}
                {showPasswordFields && (
                    <VerticalStringInput
                        id="password_confirmation"
                        size="l"
                        label="パスワード確認"
                        type="password"
                        placeholder="6文字以上"
                        state={state.fields.password_confirmation}
                    />
                )}
                <ButtonWrapper>
                    <SubmitButton id="submit-button" loading={submitting} onClick={onSubmit}>
                        {buttonLabel}
                    </SubmitButton>
                </ButtonWrapper>
            </>
        );
    }
}
